import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import useInit from './hooks/useInit'
import DeleteModalProps from './types/DeleteModalProps'


const DeleteModal: React.FunctionComponent<DeleteModalProps> = (props : DeleteModalProps) => {
  const [modalBody, setModalBody] = useState<React.ReactElement>(<></>)
  const [modalLoaded, setModalLoaded] = useState<boolean>(false)

  useInit({
    ...props,
    setModalBody,
    setModalLoaded,
  })

  return (
    <Modal
      show={props.showModal && modalLoaded}
      onHide={() => props.setShowModal(false)}
      animation={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>Delete {props.entityName}</Modal.Title>
      </Modal.Header>
      {modalBody}
    </Modal>
  )
}

export default DeleteModal
